import script from "./LeagueBreadcrumbs.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueBreadcrumbs.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueBreadcrumbs.vue?vue&type=style&index=0&id=7ce3f272&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ce3f272"]])

export default __exports__